import React, { Component } from 'react';
import { GA_Push } from "../Services/Analytics"
import { apiURL ,Environment } from "../Services/baseURL"
import Header from "../Header/Header"
import Welcome from '../Welcome/Welcome';
import ManotFalafel from '../ManotFalafel/ManotFalafel';
import ManotSelected from '../ManotSelected/ManotSelected';
import Popup from '../Popup/Popup';
import Footer from '../Footer/Footer';
import { _setCookie, _getCookie } from '../Services/Cookies';
import { loadReCaptcha } from 'react-recaptcha-google'

class App extends Component {
  constructor() {
    super();
    this.state = {
      current: 0,
      removeSelected: -1,
      chooseMeal: -1,
      mealsSelected: [{ "ID": 1 }],
      popupData: {
        data: {},
        isChoosen: ""
      },
      busy: false,
      showLoader: false,
      isPoping: false,
      captchaEnable: !Environment().isLocalhost
    }
    this.getMeal = this.getMeal.bind(this);
    this.removeSelected = this.removeSelected.bind(this);
    this.showLoader = this.showLoader.bind(this);
    this.triggerPopup = this.triggerPopup.bind(this);
    this.chooseMeal = this.chooseMeal.bind(this);
    this.sendVotes = this.sendVotes.bind(this);
    // window.sendCallback = this.sendVotes;
  }
  getMeal(_meal, count) {
    const _mealsSelected = this.state.mealsSelected;
    if (_mealsSelected.indexOf(_meal) < 1) {
      _mealsSelected.push(_meal);
    } else {
      _mealsSelected.splice(_mealsSelected.indexOf(_meal), 1);
    }
    this.setState({
      current: count,
      mealsSelected: (count == 0 ? [{ "ID": 1 }] : _mealsSelected)
    })
  }

  //Component did mount life-cycle
  // componentDidMount() {
  //   setTimeout(() => {
  //       window.grecaptcha.render('recaptcha-main'); // 'recaptcha-main' is the id that was assigned to the widget
  //   }, 4000);
  // }
  componentDidMount(){
    loadReCaptcha();
  }

  removeSelected(id) {
    this.setState({
      removeSelected: id
    })
    window.setTimeout(() => {
      this.setState({
        removeSelected: -1
      })
    }, 250)
  }
  showLoader() {
    this.setState({
      showLoader: !this.state.showLoader
    })
  }
  triggerPopup(data, isChoosen) {
    this.setState({
      isPoping: !this.state.isPoping,
    });
    if (data) {
      this.setState({
        popupData: {
          data,
          isChoosen: isChoosen
        }
      })
    }
  }
  chooseMeal(id) {
    this.setState({
      chooseMeal: id
    })
    window.setTimeout(() => {
      this.setState({
        chooseMeal: -1
      })
    }, 250)
  }
  sendVotes() {
    if (_getCookie("asdljlkads")) {
      this.triggerPopup({
        Title: "לא ניתן להצביע יותר מפעם אחת",
        Describe: ""
      }, "")
      return;
    }
    const items = [];
    if (this.state.current == 0) {
      this.triggerPopup({
        Title: "יש לבחור מועמד",
        Describe: ""
      }, "")
      return;
    }
    if (this.state.current != 1) {
      this.triggerPopup({
        Title: "יש לבחור מועמד",
        Describe: ""
      }, "")
      return;
    }

    this.state.mealsSelected.forEach(item => {
      items.push(item["ID"])
    });

    if (this.state.busy) {
      return;
    }
    this.showLoader();
    this.setState({
      busy: true
    })
    // Reset the Captcha
    // this.state.captchaEnable && window.grecaptcha.reset();
    fetch(`${apiURL}save`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(items)
    }).then(data => {
      _setCookie("asdljlkads", 1, 60 * 24 * 31);
      this.triggerPopup({
        Title: "בחירתך נשלחה בהצלחה!",
        Describe: ""
      }, "")
      this.showLoader();
      GA_Push("Form_Events", "Form Submission", "Success", "Forms");

      this.state.mealsSelected.splice(1, 3).forEach((item, index) => {
        this.getMeal(item, Math.round(this.props.current - 1))
        this.removeSelected(item.ID);
      })

      this.setState({
        busy: false
      })
    }).catch(e => {
      GA_Push("Form_Events", "Form Submission", "Fail", "Forms");
    });
  }
  render() {
    return (
      <div className={`App`}>
        <Header />
        <Popup
          chooseMeal={this.chooseMeal}
          popupData={this.state.popupData}
          triggerPopup={this.triggerPopup}
          isPoping={this.state.isPoping}
          isLoading={this.state.showLoader}
          getMeal={this.getMeal}
          removeSelected={this.state.removeSelected}
          current={this.state.current} />
        <Welcome />
        <ManotFalafel
          triggerPopup={this.triggerPopup}
          showLoader={this.showLoader}
          isLoading={this.state.showLoader}
          chooseMeal={this.state.chooseMeal}
          getMeal={this.getMeal}
          removeSelected={this.state.removeSelected}
          sendCallback={this.sendVotes}
          current={this.state.current} />
        {/* <ManotSelected
          triggerPopup={this.triggerPopup}
          showLoader={this.showLoader}
          getMeal={this.getMeal}
          mealsSelected={this.state.mealsSelected}
          removeSelected={this.removeSelected}
          current={this.state.current} /> */}
        <Footer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/Components/App/App.jsx